module.exports = __webpack_public_path__ + "static/apple-icon-120x120-001daff2db3b383cd1634a167e7cebfe.png";